export default "__VITE_ASSET__CMXP6j33__"